import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `templates:` scope (F1 "Start faster"
 * gallery, `/templates`) — see `apps/web/src/routes/settings/drive/
 * drive.i18n.ts`'s doc comment for the pattern this follows (mirrors
 * `apps/web/src/routes/personas/personas.i18n.ts` exactly).
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/templates.json`.
 */
const en = {
  'page.eyebrow': 'Start faster',
  'page.title': 'Templates',
  'page.subcopy': 'Pick a structure to pre-fill the generation wizard.',

  'kind.all': 'All',
  'kind.book': 'Book',
  'kind.article': 'Article',
  'kind.report': 'Report',

  'list.searchLabel': 'Search templates',
  'list.searchPlaceholder': 'Search by name…',
  'list.empty.title': 'No templates yet',
  'list.empty.description': 'Templates pre-fill a structure so you can jump straight into drafting.',
  'list.empty.action': 'Start from scratch',
  'list.noResults.title': 'No templates match “{query}”',
  'list.noResults.description': 'Try a different search.',
  'list.error.title': "Couldn't load templates.",

  'action.retry': 'Retry',
  'action.useTemplate': 'Use template',

  'card.noDescription': 'No description yet.',
} as const;

const ro: Record<keyof typeof en, string> = {
  'page.eyebrow': 'Pornește mai repede',
  'page.title': 'Șabloane',
  'page.subcopy': 'Alege o structură pentru a pre-completa expertul de generare.',

  'kind.all': 'Toate',
  'kind.book': 'Carte',
  'kind.article': 'Articol',
  'kind.report': 'Raport',

  'list.searchLabel': 'Caută șabloane',
  'list.searchPlaceholder': 'Caută după nume…',
  'list.empty.title': 'Niciun șablon încă',
  'list.empty.description': 'Șabloanele pre-completează o structură, ca să treci direct la redactare.',
  'list.empty.action': 'Pornește de la zero',
  'list.noResults.title': 'Niciun șablon nu se potrivește cu „{query}”',
  'list.noResults.description': 'Încearcă o altă căutare.',
  'list.error.title': 'Nu am putut încărca șabloanele.',

  'action.retry': 'Reîncearcă',
  'action.useTemplate': 'Folosește șablonul',

  'card.noDescription': 'Fără descriere încă.',
};

export const TEMPLATES_CATALOG: Record<Locale, Record<keyof typeof en, string>> = { en, ro };

export type TemplatesCatalogKey = keyof typeof en;
